window.addEventListener('DOMContentLoaded', () => {

    // // get the header .sticky__header 
    // const header = document.querySelector('.sticky__header');
    // // on scroll event add class .fixed to the header
    window.addEventListener('scroll', () => {
        // get adminbar
        let adminBar = document.querySelector('#wpadminbar');
        let adminBarHeight = 0;

        if (adminBar) {
            // Get admin bar height
            adminBarHeight = adminBar.offsetHeight;
        }

        // get the header .header__wrapper
        const header = document.querySelector('.header__wrapper');
        // add adminBarHeight to top of header
        header.style.top = adminBarHeight + 'px';
        // check if the page is scrolled more than 10px, add class .shadow to the header
        if (window.scrollY > 10) {
            header.classList.add('shadow');
        } else {
            // remove class .shadow from the header
            header.classList.remove('shadow');
        }

    });




});